import { openReportState } from 'app/area/favourite/constants';
import { CodeActionType } from 'app/area/codetable/item/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

/* eslint-disable max-len*/
export const CodeSelectorFor = {
  ConnectedCaseType: 'connectedcasetype',
  CaseType: 'casetype',
  Dashboard: 'dashboard',
  SavedReport: 'savedreport',
  SavedCompanyReport: 'savedcompanyreport',
  CompanyReport: 'companyreport',
  ChangeCaseType: 'changecasetype',
  CodetableAdministration: 'codetableadministration',
  SavedDashboard: 'saveddashboard'
};

export const routeName = {
  Administration: 'administration',
  Bowtie: 'bowtie',
  Case: 'case',
  CreateDraft: 'create',
  CaseReceipt: 'receipt',
  ChangeCaseType: 'change-casetype',
  Dashboard: 'dashboard',
  Draft: 'draft',
  Favourite: 'favourite',
  UserProfile: 'userprofile',
  SavedReport: 'savedreport',
  CompanyReport: 'companyreport',
  Select: 'select',
  MyDownloads: 'mydownloads',
  Import: 'import',
  Help: 'help',
  SavedReports: 'savedreports',
  MessagesToUser: 'messages',
  TextConfiguration: 'text',
  CodeDescription: 'code-description',
  IndicatorFactors: 'indicatorfactors',
  LinkCodes: 'link-codes',
  CompanyReports: 'companyreport',
  ImportSets: 'importsets',
  Links: 'links',
  LinkGroups: 'linkgroups',
  CodeMappings: 'codemappings',
  ImportMappings: 'importmappings'
};

export enum UserProfileSectionType {
  Settings = 'settings',
  Notifications = 'notifications',
  DefaultValues = 'defaultvalues',
  Subscriptions = 'subscriptions'
}

export const codetableBreadcrumbs = (breadcrumbs: number[]) =>
  !!breadcrumbs && breadcrumbs.length > 0 ? breadcrumbs.reduce((result, breadcrumb) => `${result}/${breadcrumb}`, '') : '';

export const routeConstants = {

  startupView: '/',

  draftView: `/${routeName.Draft}/:id`,
  draftViewFor: (draftId: number) => `/${routeName.Draft}/${draftId}`,

  createCase: (caseType: number) => `/${routeName.CreateDraft}/${caseType}`,
  createDraft: `/${routeName.CreateDraft}/:caseTypeId`,

  changeCaseTypeTo: (caseType: number) => `/${routeName.ChangeCaseType}/${caseType}`,
  changeCaseType: `/${routeName.ChangeCaseType}/:caseTypeId`,

  favouriteFor: (favouriteId: number) => {
    return `/${routeName.Favourite}/${favouriteId}`;
  },
  createFavouriteDraft: `/${routeName.Favourite}/draft`,
  favouriteDraftNew: `/${routeName.Favourite}/${openReportState.new}`,

  favouriteView: `/${routeName.Favourite}/draft/:favouriteId`,
  favouriteViewFor: (favouriteId: number) => {
    return `/${routeName.Favourite}/draft/${favouriteId}`;
  },

  caseView: `/${routeName.Case}/:id`,
  caseViewFor: caseNumber => `/${routeName.Case}/${caseNumber}`,

  caseReceipt: `${routeName.CaseReceipt}/:id`,
  caseReceiptFor: caseNumber => `/${routeName.CaseReceipt}/${caseNumber}`,

  caseEdit: `/${routeName.Case}/:id/edit`,
  caseEditFor: (caseNumber: number) => {
    return `/${routeName.Case}/${caseNumber}/edit`;
  },

  caseDuplicate: `/${routeName.Case}/:id/duplicate`,
  caseDuplicateFor: (caseNumber: number) => `/${routeName.Case}/${caseNumber}/duplicate`,

  dashboardView: `/${routeName.Dashboard}/:dashboardType/favourite/draft`,
  dashboardFor: (dashboardType: number) => {
    return `/${routeName.Dashboard}/${dashboardType}/favourite/draft`;
  },
  dashboardWithFavouriteFor: (dashboardType: number, favouriteId: number) => {
    return `/${routeName.Dashboard}/${dashboardType}/favourite/draft/${favouriteId}`;
  },
  savedDashboard: `/${routeName.Dashboard}/:dashboardType/${routeName.Favourite}/:validFavouriteId`,
  savedDashboardModifier1: `/${routeName.Dashboard}/:dashboardType/:modifier1/${routeName.Favourite}/:validFavouriteId`,
  savedDashboardModifier2: `/${routeName.Dashboard}/:dashboardType/${routeName.Favourite}/:validFavouriteId/:modifier2`,
  savedDashboardModifier1and2: `/${routeName.Dashboard}/:dashboardType/:modifier1/${routeName.Favourite}/:validFavouriteId/:modifier2`,

  dashboardFavourite: `/${routeName.Dashboard}/${routeName.Favourite}/:favouriteId`,
  savedDashboardFor: (value: number[]) => {
    return `/${routeName.Dashboard}/${routeName.Favourite}/${value?.[0]}`;
  },

  savedFavourite: `/${routeName.Favourite}/:validFavouriteId`,
  savedFavouriteWithAction: `/${routeName.Favourite}/:validFavouriteId/:modifier1`,

  companyReportView: `/${routeName.CompanyReport}/:companyReportId`,

  savedReportFor: (value: number[]) => {
    return `/${routeName.Favourite}/${value?.[0]}`;
  },
  companyReportFor: (id: number) => {
    return `/${routeName.CompanyReport}/${id}`;
  },

  savedCompanyReport: `/${routeName.CompanyReport}/:companyReportId/${routeName.Favourite}/:validFavouriteId`,
  savedCompanyReportModifier1: `/${routeName.CompanyReport}/:companyReportId/:modifier1/${routeName.Favourite}/:validFavouriteId`,
  savedCompanyReportModifier2: `/${routeName.CompanyReport}/:companyReportId/${routeName.Favourite}/:validFavouriteId/:modifier2`,
  savedCompanyReportModifier1and2: `/${routeName.CompanyReport}/:companyReportId/:modifier1/${routeName.Favourite}/:validFavouriteId/:modifier2`,
  savedCompanyReportFor: (value: number[]) => {
    return `/${routeName.CompanyReport}/${value?.[1] ? value[1] + '/' : ''}${routeName.Favourite}/${value?.[0]}`;
  },
  companyReportFavouriteDraft: `/${routeName.CompanyReport}/:companyReportId/${routeName.Favourite}/draft/:favouriteId`,

  companyReportFavourite: `/${routeName.CompanyReport}/${routeName.Favourite}/:favouriteId`,

  userProfileActiveSection: (activeSection: string) => `/${routeName.UserProfile}/${activeSection}`,
  userProfileMainView: `/${routeName.UserProfile}`,
  userProfileMainViewFocus: `/${routeName.UserProfile}/:focus`,
  userProfileViewWithFocusFor: (id: string) => `/${routeName.UserProfile}/settings?focus=${id}`,

  userSearchView: `/${routeName.Administration}/list`,

  rolesView: `/${routeName.Administration}/roles`,

  roleAdd: `/${routeName.Administration}/role/:actionType`,
  roleAddFor: (actionType: string) => `/${routeName.Administration}/role/${actionType}`,
  roleAddSectionFor: (section: string) => `/${routeName.Administration}/role/add/section/${section}`,

  roleEdit: `/${routeName.Administration}/role/:id/:actionType`,
  roleEditSection: `/${routeName.Administration}/role/:id/:actionType/section/:section`,
  roleEditFor: (id: number) => `/${routeName.Administration}/role/${id}/edit`,
  roleEditSectionFor: (id: number, section: string) => `/${routeName.Administration}/role/${id}/edit/section/${section}`,

  roleDuplicate: `/${routeName.Administration}/role/:id/:actionType`,
  roleDuplicateSection: `/${routeName.Administration}/role/:id/:actionType/section/:section`,
  roleDuplicateFor: (id: number) => `/${routeName.Administration}/role/${id}/duplicate`,
  roleDuplicateSectionFor: (id: number, section: string) => `/${routeName.Administration}/role/${id}/duplicate/section/${section}`,

  userAdd: `/${routeName.Administration}/user/:actionType`,
  userAddSection: `/${routeName.Administration}/user/:actionType/section/:section`,
  userAddFor: (actionType: string) => `/${routeName.Administration}/user/${actionType}`,
  userAddSectionFor: (section: string) => `/${routeName.Administration}/user/add/section/${section}`,

  userEdit: `/${routeName.Administration}/user/:id/:actionType`,
  userEditFor: (id: number) => `/${routeName.Administration}/user/${id}/edit`,
  userEditSectionFor: (id: number, section: string) => `/${routeName.Administration}/user/${id}/edit/section/${section}`,

  userDuplicate: `/${routeName.Administration}/user/:id/:actionType`,
  userDuplicateSection: `/${routeName.Administration}/user/:id/:actionType/section/:section`,
  userDuplicateFor: (id: number) => `/${routeName.Administration}/user/${id}/duplicate`,
  userDuplicateSectionFor: (id: number, section: string) => `/${routeName.Administration}/user/${id}/duplicate/section/${section}`,

  codetableAdministration: `/${routeName.Administration}/optionsCollection/`,
  codetableAdministrationFor: (breadcrumbs: number[]) => `/${routeName.Administration}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}`,
  codetableAdministrationCodeFor: (breadcrumbs: number[], codeId: number, actionType: CodeActionType) =>
    `/${routeName.Administration}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/${actionType}/code/${codeId}`,

  codetableAdministrationDuplicateCodeFor: (breadcrumbs: number[], codeId: number, parentId?: number) =>
    `/${routeName.Administration}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/duplicate/code/${codeId}`
    + (isDefinedIncludingZero(parentId) ? `?parentId=${parentId}` : ''),

  codetableAdministrationAddCodeFor: (breadcrumbs: number[], parentId?: number) =>
    `/${routeName.Administration}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/add/code`
    + (parentId !== undefined ? `?parentId=${parentId}` : ''),
  codetableAdministrationCodeSectionFor: (breadcrumbs: number[], codeId: number, section: string, actionType: CodeActionType) =>
    `/${routeName.Administration}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/${actionType}/code/${codeId}/section/${section}`,
  codetableAdministrationAddCodeSectionFor: (breadcrumbs: number[], section: string) =>
    `/${routeName.Administration}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/add/code/section/${section}`,

  codetableLinkCodes: `/${routeName.Administration}/${routeName.LinkCodes}`,
  codetableLinkCodesPrefix: `/${routeName.Administration}/${routeName.LinkCodes}/`,
  codetableLinkCodesFor: (breadcrumbs: number[]) =>
    `/${routeName.Administration}/${routeName.LinkCodes}${codetableBreadcrumbs(breadcrumbs)}`,

  indicatorFactorsAdministration: `/${routeName.Administration}/${routeName.IndicatorFactors}/optionsCollection/`,
  indicatorFactorsAdministrationFor: (breadcrumbs: number[]) =>
    `/${routeName.Administration}/${routeName.IndicatorFactors}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}`,

  indicatorFactorsAdministrationCodeFor: (breadcrumbs: number[], codeId: number, actionType: CodeActionType) =>
    `/${routeName.Administration}/${routeName.IndicatorFactors}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/${actionType}/code/${codeId}`,

  indicatorFactorsAdministrationDuplicateCodeFor: (breadcrumbs: number[], codeId: number) =>
    `/${routeName.Administration}/${routeName.IndicatorFactors}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/duplicate/code/${codeId}`,

  indicatorFactorsAdministrationAddCodeFor: (breadcrumbs: number[], parentId?: number) =>
    `/${routeName.Administration}/${routeName.IndicatorFactors}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/add/code`
    + (parentId !== undefined ? `?parentId=${parentId}` : ''),
  indicatorFactorsAdministrationCodeSectionFor: (breadcrumbs: number[], codeId: number, section: string, actionType: CodeActionType) =>
    `/${routeName.Administration}/${routeName.IndicatorFactors}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/${actionType}/code/${codeId}/section/${section}`,
  indicatorFactorsAdministrationAddCodeSectionFor: (breadcrumbs: number[], section: string) =>
    `/${routeName.Administration}/${routeName.IndicatorFactors}/optionsCollection${codetableBreadcrumbs(breadcrumbs)}/add/code/section/${section}`,

  textConfigurationList: `/${routeName.Administration}/${routeName.TextConfiguration}`,
  textConfigurationAdd: `/${routeName.Administration}/${routeName.TextConfiguration}/add`,
  textConfigurationItem: `/${routeName.Administration}/${routeName.TextConfiguration}/:textId/textSet/:textSet`,
  textConfigurationItemFor: (textId: number, textSet: number) =>
    `/${routeName.Administration}/${routeName.TextConfiguration}/${textId}/textSet/${textSet}`,

  codeDescriptionList: `/${routeName.Administration}/${routeName.CodeDescription}`,

  bowtie: `/${routeName.Bowtie}`,
  bowtieView: `/${routeName.Bowtie}/:id`,
  bowtieViewFor: (caseNumber) => `/${routeName.Bowtie}/${caseNumber}`,

  caseSection: (sectionId, expandAll) => `?section=${sectionId}${expandAll ? '&expandAll' : ''}`,
  caseSectionFor: (caseNumber, sectionId) => `/${routeName.Case}/${caseNumber}${routeConstants.caseSection(sectionId, false)}`,

  caseViewEvaluation: (entityPath: string, sectionNumber: number) => `/${routeName.Case}/${entityPath}?section=${sectionNumber}`,

  select: `/${routeName.Select}/:type`,
  selectCodetableId: `/${routeName.Select}/:type/`,
  selectDashboard: `/${routeName.Select}/${CodeSelectorFor.Dashboard}`,

  selectSavedDashboards: `/${routeName.Select}/${CodeSelectorFor.SavedDashboard}`,
  selectSavedDashboard: `/${routeName.Select}/${CodeSelectorFor.SavedDashboard}?folder=/:selectedFolderId&favourite=/:favouriteId`,
  selectSavedDashboardFor: (selectedFolderId?: number, favouriteId?: number) => `/${routeName.Select}/${CodeSelectorFor.SavedDashboard}?${selectedFolderId ? `folder=${selectedFolderId}` : ''}${favouriteId ? `${selectedFolderId ? '&' : ''}favouriteId=${favouriteId}` : ''}`,

  selectCompanyReports: `/${routeName.Select}/${CodeSelectorFor.CompanyReport}`,
  selectCaseType: `/${routeName.Select}/${CodeSelectorFor.CaseType}`,
  selectChangeCaseType: `/${routeName.Select}/${CodeSelectorFor.ChangeCaseType}`,
  selectConnectedCaseType: `/${routeName.Select}/${CodeSelectorFor.ConnectedCaseType}`,
  selectSavedReports: `/${routeName.Select}/${CodeSelectorFor.SavedReport}`,
  selectSavedReportFor: (selectedFolderId?: number, favouriteId?: number) => `/${routeName.Select}/${CodeSelectorFor.SavedReport}?${selectedFolderId ? `folder=${selectedFolderId}` : ''}${favouriteId ? `${selectedFolderId ? '&' : ''}favouriteId=${favouriteId}` : ''}`,
  selectSavedCompanyReports: `/${routeName.Select}/${CodeSelectorFor.SavedCompanyReport}`,
  selectSavedCompanyReport: `/${routeName.Select}/${CodeSelectorFor.SavedCompanyReport}?folder=/:selectedFolderId&favourite=/:favouriteId`,
  selectSavedCompanyReportFor: (selectedFolderId?: number, favouriteId?: number) => `/${routeName.Select}/${CodeSelectorFor.SavedCompanyReport}?${selectedFolderId ? `folder=${selectedFolderId}` : ''}${favouriteId ? `${selectedFolderId ? '&' : ''}favouriteId=${favouriteId}` : ''}`,
  selectCodetableAdministration: `/${routeName.Select}/${CodeSelectorFor.CodetableAdministration}`,

  myDownloadsView: `/${routeName.MyDownloads}`,
  importView: `/${routeName.Import}`,
  messagesToUserView: `/${routeName.MessagesToUser}`,

  administrationMessagesList: `/${routeName.Administration}/${routeName.MessagesToUser}`,
  administrationMessagesAdd: `/${routeName.Administration}/${routeName.MessagesToUser}/add`,
  administrationMessagesItem: `/${routeName.Administration}/${routeName.MessagesToUser}/:id`,
  administrationMessagesItemFor: (id: number) => `/${routeName.Administration}/${routeName.MessagesToUser}/${id}`,

  dashboardAdminList: `/${routeName.Administration}/${routeName.Dashboard}`,
  dashboardAdminAdd: `/${routeName.Administration}/${routeName.Dashboard}/add`,
  dashboardAdminAddFor: (section?: string) => `/${routeName.Administration}/${routeName.Dashboard}/add${section ? `/section/${section}` : ''}`,
  dashboardAdminItem: `/${routeName.Administration}/${routeName.Dashboard}/:id`,
  dashboardAdminItemSection: `/${routeName.Administration}/${routeName.Dashboard}/:id/section/:section`,
  dashboardAdminItemFor: (id: number, favouriteId?: number, section?: string) => `/${routeName.Administration}/${routeName.Dashboard}/${id}${section ? `/section/${section}` : ''}${favouriteId ? `?favouriteId=${favouriteId}` : ''}`,
  dashboardAdminSavedReports: `/${routeName.Administration}/${routeName.Dashboard}/:id/${routeName.SavedReports}`,
  dashboardAdminSavedReportsFor: (id: number, favouriteId?: number) => `/${routeName.Administration}/${routeName.Dashboard}/${id}/${routeName.SavedReports}${favouriteId ? `?favouriteId=${favouriteId}` : ''}`,

  companyReportAdminList: `/${routeName.Administration}/${routeName.CompanyReports}`,
  companyReportAdminAdd: `/${routeName.Administration}/${routeName.CompanyReports}/add`,
  companyReportAdminAddFor: (section?: string) => `/${routeName.Administration}/${routeName.CompanyReports}/add${section ? `/section/${section}` : ''}`,
  companyReportAdminItem: `/${routeName.Administration}/${routeName.CompanyReports}/:id`,
  companyReportAdminItemFor: (id: number, section?: string) => `/${routeName.Administration}/${routeName.CompanyReports}/${id}${section ? `/section/${section}` : ''}`,
  companyReportAdminItemSection: `/${routeName.Administration}/${routeName.CompanyReports}/:id/section/:section`,

  favouriteAdminList: `/${routeName.Administration}/${routeName.Favourite}`,
  favouriteAdminItem: `/${routeName.Administration}/${routeName.Favourite}/:id`,
  favouriteAdminItemFor: (id: number, section?: string) => `/${routeName.Administration}/${routeName.Favourite}/${id}${section ? `/section/${section}` : ''}`,
  favouriteAdminItemSection: `/${routeName.Administration}/${routeName.Favourite}/:id/section/:section`,

  importSetList: `/${routeName.Administration}/${routeName.ImportSets}`,
  importSetAdd: `/${routeName.Administration}/${routeName.ImportSets}/:actionType`,
  importSetAddFor: (section?: string) => `/${routeName.Administration}/${routeName.ImportSets}/add${section ? `/section/${section}` : ''}`,
  importSetAddSection: `/${routeName.Administration}/${routeName.ImportSets}/:actionType/section/:section`,
  importSetCodeLikeCode: `/${routeName.Administration}/${routeName.ImportSets}/:actionType`,
  importSetCodeLikeCodeFor: (section?: string) => `/${routeName.Administration}/${routeName.ImportSets}/codelikecode${section ? `/section/${section}` : ''}`,
  importSetCodeLikeCodeSection: `/${routeName.Administration}/${routeName.ImportSets}/:actionType/section/:section`,
  importSetDuplicate: `/${routeName.Administration}/${routeName.ImportSets}/:actionType/:id`,
  importSetDuplicateFor: (id: number, section?: string) => `/${routeName.Administration}/${routeName.ImportSets}/duplicate/${id}${section ? `/section/${section}` : ''}`,
  importSetDuplicateSection: `/${routeName.Administration}/${routeName.ImportSets}/:actionType/:id/section/:section`,
  importSetEdit: `/${routeName.Administration}/${routeName.ImportSets}/:actionType/:id`,
  importSetEditFor: (id: number, section?: string) => `/${routeName.Administration}/${routeName.ImportSets}/edit/${id}${section ? `/section/${section}` : ''}`,
  importSetEditSection: `/${routeName.Administration}/${routeName.ImportSets}/:actionType/:id/section/:section`,

  codeMappings: `/${routeName.Administration}/${routeName.CodeMappings}/:id`,
  codeMappingsFor: (id: number) => `/${routeName.Administration}/${routeName.CodeMappings}/${id}`,

  importMappings: `/${routeName.Administration}/${routeName.ImportMappings}`,
  importMappingsImportSetOnly:
    `/${routeName.Administration}/${routeName.ImportMappings}/importset/:importset`,
  importMappingsEdit:
    `/${routeName.Administration}/${routeName.ImportMappings}/importset/:importset/codetable/:codetable`,
  importMappingsEditFor: (importSetId: number, codetableId: number) =>
    `/${routeName.Administration}/${routeName.ImportMappings}/importset/${importSetId}/codetable/${codetableId}`,
  importMappingsImportSetOnlyFor: (importSetId: number) =>
    `/${routeName.Administration}/${routeName.ImportMappings}/importset/${importSetId}`,

  externalUrlList: `/${routeName.Administration}/${routeName.Links}`,
  externalUrlAdd: `/${routeName.Administration}/${routeName.Links}/:actionType`,
  externalUrlAddFor: (section?: string) => `/${routeName.Administration}/${routeName.Links}/add${section ? `/section/${section}` : ''}`,
  externalUrlAddSection: `/${routeName.Administration}/${routeName.Links}/:actionType/section/:section`,
  externalUrlEdit: `/${routeName.Administration}/${routeName.Links}/:actionType/:id`,
  externalUrlEditFor: (id: number, section?: string) => `/${routeName.Administration}/${routeName.Links}/edit/${id}${section ? `/section/${section}` : ''}`,
  externalUrlEditSection: `/${routeName.Administration}/${routeName.Links}/:actionType/:id/section/:section`,

  externalUrlGroupsList: `/${routeName.Administration}/${routeName.LinkGroups}`,
  externalUrlGroupsAdd: `/${routeName.Administration}/${routeName.LinkGroups}/:actionType`,
  externalUrlGroupsAddFor: (section?: string) => `/${routeName.Administration}/${routeName.LinkGroups}/add${section ? `/section/${section}` : ''}`,
  externalUrlGroupsAddSection: `/${routeName.Administration}/${routeName.LinkGroups}/:actionType/section/:section`,
  externalUrlGroupsEdit: `/${routeName.Administration}/${routeName.LinkGroups}/:actionType/:id`,
  externalUrlGroupsEditFor: (id: number, section?: string) => `/${routeName.Administration}/${routeName.LinkGroups}/edit/${id}${section ? `/section/${section}` : ''}`,
  externalUrlGroupsEditSection: `/${routeName.Administration}/${routeName.LinkGroups}/:actionType/:id/section/:section`,

  section: 'section/:section',
  edit: '/edit',
  actionTypeCode: '/:actionType/code',
  actionTypeCodeId: '/:actionType/code/:codeId',

  favouriteWithParams: (params: string) => {
    return `/${routeName.Administration}/${routeName.Favourite}?${params}`;
  },

  logout: '/logout'
};
